import React from "react";
import { addClassNames } from "../Functions/Helper/Component";
import { Copy } from "./Generic/Icons";

function technicalDetails(error) {
    if (!error) return "No error details available.";
    if (error.isAggregate) {
        return `Aggregate Error: ${error?.message}\n\n`
            + error.errors.map((e, idx) => `Error ${idx + 1}:\n${technicalDetails(e)}`).join("\n\n");
    }
    return error?.stack || error?.message || JSON.stringify(error);
}

export function ErrorMessage({className, action, error}) {
    const message = React.useMemo(() => 
        "Dear MyCareerBrand Support,\n\n"
        + `I encountered the following error while ${action}:\n\n` 
        + `Could you please assist me in resolving this issue?\n\n`
        + `Thank you.\n\n`
        + `Technical details:\n`
        + technicalDetails(error) + `\n`
    , [error, action]);
    const href = React.useMemo(() => (
        "mailto:support@mycareerbrand.net?subject="
        + encodeURIComponent(`Error while ${action}`)
        + "&body=" + encodeURIComponent(message)
    ), [action, message]);
    const iconRef = React.useRef(null);
    return (
        <p className={addClassNames("error-message", className)}>
            {error.userReadable ? error.message : (
                <>
                    Error occured while {action}.<br/>
                    Please contact <a href={href} target="__blank" style={{ marginLeft: "0.5rem", textDecoration: "underline" }
                        }>support@mycareerbrand.net</a><br/>
                    <a href="#-copy" className="fs-small text-decoration-none" onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText(message);
                        if (iconRef.current) {
                            iconRef.current.classList.remove("bi-copy");
                            iconRef.current.classList.add("bi-check");
                            setTimeout(() => {
                                iconRef.current.classList.add("bi-copy");
                                iconRef.current.classList.remove("bi-check");
                            }, 3000);
                        }
                    }}>
                        <small className="error-message">( <Copy ref={iconRef}  className="icon"/>click here to copy technical message. )</small>
                    </a>
                </>
            )}
        </p>
    );
}